export enum AlertMessages {
  noPermissionInvoices = "alert.noPermission.invoices",
  noPermissionCreditLimit = "alert.noPermission.creditLimit",
  noPermissionCertificates = "alert.noPermission.certificates",
  noPermissionConcretingRequest = "alert.noPermission.concretingRequest",
  noPermissionInvoicesSpecificClient = "alert.noPermission.invoices.specificClient",
  noPermissionCreditLimitSpecificClient = "alert.noPermission.creditLimit.specificClient",
  noPermissionCertificatesSpecificClient = "alert.noPermission.certificates.specificClient",
  noPermissionConcretingRequestSpecificClient = "alert.noPermission.concretingRequest.specificClient",
  noHaveInvoices = "alert.noHave.invoices",
  noHaveCertificates = "alert.noHave.certificates",
  noHaveInvoicesSpecificClient = "alert.noHave.invoices.specificClient",
  noHaveCertificatesSpecificClient = "alert.noHave.certificates.specificClient",
  noHaveConcretingRequestSpecificClient = "alert.noHave.concretingRequest.specificClient",
  noConcretingApproval = "alert.noConcretingApproval",
  noConcreting = "alert.noConcreting",
  noContract = "alert.noContract",
  noUser = "alert.noUser"
}

export interface TranslationAlertMessages {
  [AlertMessages.noPermissionCreditLimit]: string;
  [AlertMessages.noPermissionInvoices]: string;
  [AlertMessages.noPermissionCertificates]: string;
  [AlertMessages.noPermissionConcretingRequest]: string;
  [AlertMessages.noPermissionCreditLimitSpecificClient]: string;
  [AlertMessages.noPermissionInvoicesSpecificClient]: string;
  [AlertMessages.noPermissionCertificatesSpecificClient]: string;
  [AlertMessages.noPermissionConcretingRequestSpecificClient]: string;
  [AlertMessages.noHaveInvoices]: string;
  [AlertMessages.noHaveCertificates]: string;
  [AlertMessages.noHaveInvoicesSpecificClient]: string;
  [AlertMessages.noHaveCertificatesSpecificClient]: string;
  [AlertMessages.noHaveConcretingRequestSpecificClient]: string;
  [AlertMessages.noConcretingApproval]: string;
  [AlertMessages.noConcreting]: string;
  [AlertMessages.noContract]: string;
  [AlertMessages.noUser]: string;
}
